import styled from "styled-components";
import Button from "../Button";

const Wrapper = styled.section`
  display: grid;
  gap: 0.85rem;
  justify-items: start;
  width: min(1120px, calc(100% - 2rem));
  margin: 0 auto;
  padding: 1.75rem;
  border: 1px solid ${({ theme }) => theme.colors.border};
  border-radius: ${({ theme }) => theme.radii.lg};
  background: rgba(255, 255, 255, 0.05);
  backdrop-filter: blur(18px);
`;

const Title = styled.h2`
  margin: 0;
  font-size: clamp(1.4rem, 2vw, 1.8rem);
`;

const Description = styled.p`
  margin: 0;
  max-width: 62ch;
  color: ${({ theme }) => theme.colors.textMuted};
  line-height: 1.6;
`;

function SectionMessage({ title, description, actionLabel, onAction }) {
  return (
    <Wrapper>
      <Title>{title}</Title>
      {description ? <Description>{description}</Description> : null}
      {actionLabel && onAction ? (
        <Button variant="secondary" onClick={onAction}>
          {actionLabel}
        </Button>
      ) : null}
    </Wrapper>
  );
}

export default SectionMessage;
